var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobGrazing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.24 89.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#151515;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,6.6A7.42,7.42,0,0,1,3,.68,3.29,3.29,0,0,1,4.17.32,5.21,5.21,0,0,1,4.4,1.4a25.11,25.11,0,0,0,1.46,8c.12.37.24.74.37,1.11a2.23,2.23,0,0,1-.61,2.62,2.61,2.61,0,0,1-2.9-.36A8.35,8.35,0,0,1,0,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.24,13.22a8.85,8.85,0,0,1-3.13,6.09,3.76,3.76,0,0,1-1.61.77,1.91,1.91,0,0,1-2.29-2.76c.57-1.38,1.39-2.66,1.9-4.05.61-1.7,1.05-3.47,1.51-5.22.23-.91.56-1.08,1.27-.41A7.66,7.66,0,0,1,28.24,13.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.83,8a22.91,22.91,0,0,1-.45,2.54,2.41,2.41,0,0,1-2.64,1.84c-1-.06-1.58-.73-1.84-2.13-.55-3-1.11-6-1.68-9C5,.24,5.35-.15,6.34.05A6.35,6.35,0,0,1,11,4.34,21,21,0,0,1,11.83,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.17,15.14c.2-3.27,1.33-6.09,4.37-7.79A6.26,6.26,0,0,1,23,6.7c1-.09,1.21.37.88,1.27l-3.18,8.71c-.51,1.39-1,1.8-2.11,1.69a2.34,2.34,0,0,1-2.32-2.22C16.2,15.83,16.2,15.51,16.17,15.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,29.69a7.44,7.44,0,0,1,3-5.92,3.75,3.75,0,0,1,1.16-.36,5.21,5.21,0,0,1,.23,1.08,25,25,0,0,0,1.46,8c.12.37.24.74.37,1.11a2.23,2.23,0,0,1-.61,2.62,2.59,2.59,0,0,1-2.9-.36A8.35,8.35,0,0,1,0,29.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.24,36.32a8.81,8.81,0,0,1-3.13,6.08,3.9,3.9,0,0,1-1.61.78,1.91,1.91,0,0,1-2.29-2.76c.57-1.38,1.39-2.66,1.9-4.06.61-1.7,1.05-3.46,1.51-5.21.23-.92.56-1.09,1.27-.41A7.66,7.66,0,0,1,28.24,36.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.83,31.05a22.7,22.7,0,0,1-.45,2.53,2.41,2.41,0,0,1-2.64,1.85c-1-.07-1.58-.73-1.84-2.13-.55-3-1.11-6-1.68-9-.19-1,.13-1.36,1.12-1.16A6.34,6.34,0,0,1,11,27.43,20.86,20.86,0,0,1,11.83,31.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.17,38.24c.2-3.27,1.33-6.1,4.37-7.79A6.45,6.45,0,0,1,23,29.79c1-.09,1.21.38.88,1.28l-3.18,8.71c-.51,1.39-1,1.79-2.11,1.68a2.34,2.34,0,0,1-2.32-2.22C16.2,38.93,16.2,38.6,16.17,38.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,52.4a7.44,7.44,0,0,1,3-5.93,3.5,3.5,0,0,1,1.16-.35A5.21,5.21,0,0,1,4.4,47.2a25,25,0,0,0,1.46,7.94c.12.37.24.75.37,1.12a2.23,2.23,0,0,1-.61,2.62,2.59,2.59,0,0,1-2.9-.37A8.31,8.31,0,0,1,0,52.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.24,59a8.85,8.85,0,0,1-3.13,6.09,3.88,3.88,0,0,1-1.61.77,1.91,1.91,0,0,1-2.29-2.76c.57-1.38,1.39-2.66,1.9-4.06.61-1.69,1.05-3.46,1.51-5.21.23-.91.56-1.09,1.27-.41A7.66,7.66,0,0,1,28.24,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.83,53.75a23.35,23.35,0,0,1-.45,2.54,2.41,2.41,0,0,1-2.64,1.84c-1-.07-1.58-.73-1.84-2.13q-.83-4.5-1.68-9c-.19-1,.13-1.37,1.12-1.17A6.34,6.34,0,0,1,11,50.13,21.29,21.29,0,0,1,11.83,53.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.17,60.94c.2-3.27,1.33-6.09,4.37-7.79A6.26,6.26,0,0,1,23,52.5c1-.09,1.21.37.88,1.27l-3.18,8.71c-.51,1.39-1,1.8-2.11,1.69a2.34,2.34,0,0,1-2.32-2.23C16.2,61.63,16.2,61.31,16.17,60.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,75.49a7.42,7.42,0,0,1,3-5.92,3.5,3.5,0,0,1,1.16-.36,5.21,5.21,0,0,1,.23,1.08,25.06,25.06,0,0,0,1.46,7.95c.12.37.24.74.37,1.11A2.23,2.23,0,0,1,5.62,82a2.59,2.59,0,0,1-2.9-.36A8.35,8.35,0,0,1,0,75.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.24,82.11a8.85,8.85,0,0,1-3.13,6.09A3.76,3.76,0,0,1,23.5,89a1.91,1.91,0,0,1-2.29-2.75c.57-1.38,1.39-2.66,1.9-4.06.61-1.7,1.05-3.46,1.51-5.22.23-.91.56-1.08,1.27-.41A7.68,7.68,0,0,1,28.24,82.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.83,76.84a22.91,22.91,0,0,1-.45,2.54,2.39,2.39,0,0,1-2.64,1.84c-1-.06-1.58-.73-1.84-2.12q-.83-4.5-1.68-9c-.19-1,.13-1.37,1.12-1.17A6.37,6.37,0,0,1,11,73.23,21,21,0,0,1,11.83,76.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.17,84c.2-3.27,1.33-6.1,4.37-7.79A6.27,6.27,0,0,1,23,75.59c1-.09,1.21.37.88,1.28l-3.18,8.7c-.51,1.39-1,1.8-2.11,1.69A2.34,2.34,0,0,1,16.24,85C16.2,84.72,16.2,84.4,16.17,84Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobGrazing);
export default __webpack_public_path__ + "static/media/mob-grazing.154becce864f6e53d9b5ec3c653121a8.svg";
export { ForwardRef as ReactComponent };